<script>
</script>

<style>
    svg {
        position: absolute;
        top: 67px;
        left: 162px;
        width: 235px;
        fill: #FFF;
    }

    .cls-1,
    .cls-2,
    .cls-3 {
        fill: #fff;
    }
    .cls-1 {
        fill-rule: evenodd;
    }
    .cls-2 {
        font-size: 16px;
        font-family: AvenirNext-Regular, Avenir Next, sans-serif;
    }
</style>

<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 656.2 40.6" style="enable-background:new 0 0 656.2 40.6;" xml:space="preserve">
    <g>
        <path class="st0" d="M16.6,16l-3.8-0.8c-1.7-0.3-3.4-1-4.9-2c-1-0.8-1.6-2-1.6-3.3c0-1,0.3-1.9,0.9-2.7c0.7-0.8,1.5-1.4,2.5-1.8
            C11,5,12.2,4.8,13.5,4.8c1.3,0,2.5,0.2,3.7,0.6c1,0.4,1.9,1,2.6,1.8C20.5,8,20.9,9,21,10l0,0.3h5.3V9.9c-0.1-1.9-0.7-3.7-1.8-5.3
            c-1.1-1.5-2.7-2.7-4.4-3.5c-2-0.8-4.3-1.3-6.5-1.2C11.4,0,9.1,0.4,7,1.3c-1.8,0.8-3.4,2-4.5,3.6c-1.1,1.5-1.7,3.4-1.7,5.3
            c-0.1,2.4,0.8,4.6,2.5,6.3c1.7,1.6,4.3,2.8,7.8,3.5l3.8,0.8c1.8,0.3,3.5,1,5,2c1,0.8,1.6,2.1,1.5,3.4c0,1-0.3,2.1-0.9,2.9
            c-0.7,0.9-1.6,1.5-2.6,1.9c-1.3,0.5-2.7,0.7-4.1,0.7c-1.4,0-2.8-0.2-4.2-0.6c-1.1-0.4-2.1-1-2.9-1.8c-0.8-0.8-1.2-1.7-1.4-2.8
            v-0.3H0v0.4c0.1,1.9,0.8,3.8,2,5.3c1.2,1.5,2.9,2.7,4.7,3.4c2.2,0.8,4.6,1.3,6.9,1.2c2.5,0.1,4.9-0.4,7.2-1.3
            c1.9-0.7,3.5-2,4.6-3.6c1.1-1.6,1.7-3.6,1.6-5.6c0.1-2.4-0.8-4.7-2.5-6.4C22.9,17.9,20.3,16.7,16.6,16z"/>
        <path class="st0" d="M52.1,27.1c-0.3,1.3-1,2.5-2,3.3c-1.1,0.9-2.5,1.4-3.9,1.3c-1.3,0-2.5-0.3-3.6-1c-1.1-0.8-1.9-1.8-2.4-3
            c-0.6-1.5-0.9-3.2-0.8-4.8c-0.1-1.6,0.2-3.2,0.8-4.8c0.5-1.2,1.3-2.2,2.4-3c1-0.8,2.3-1.2,3.6-1.2c1.5-0.1,2.9,0.4,4.1,1.4
            c1,0.9,1.6,2,1.9,3.3v0.2h5v-0.2c-0.1-1.6-0.7-3.1-1.6-4.5c-1-1.4-2.3-2.5-3.8-3.2C49.9,10.1,48,9.7,46,9.7
            c-2.2-0.1-4.5,0.5-6.4,1.6c-1.8,1.1-3.3,2.7-4.2,4.6c-1,2.2-1.6,4.6-1.5,7c-0.1,2.4,0.4,4.9,1.5,7.1c0.9,1.9,2.4,3.6,4.3,4.6
            c2,1.1,4.2,1.7,6.5,1.6c1.9,0,3.8-0.4,5.5-1.2c1.5-0.8,2.8-1.9,3.8-3.3c1-1.4,1.6-3,1.7-4.6v-0.3h-5.1V27.1z"/>
        <path class="st0" d="M83,10.9c-1.4-0.9-3.1-1.3-4.8-1.3c-1.7-0.1-3.4,0.4-4.9,1.2c-1.3,0.8-2.4,2-3,3.5h-0.1V0.6h-5.3v35.2h5.3
            V21c0-1.2,0.2-2.4,0.8-3.5c1-2,3-3.3,5.3-3.2c1.6-0.1,3.2,0.5,4.3,1.8c1.1,1.4,1.7,3.2,1.5,5v14.9h5.3V20c0-1.9-0.4-3.7-1.2-5.4
            C85.5,13.1,84.4,11.8,83,10.9z"/>
        <path class="st0" d="M113.1,11.3c-1.9-1.1-4-1.7-6.2-1.6c-2.2-0.1-4.4,0.5-6.2,1.7c-1.8,1.1-3.2,2.8-4.1,4.7
            c-1,2.2-1.5,4.6-1.5,7c-0.1,2.4,0.4,4.8,1.5,7c0.9,1.9,2.4,3.5,4.2,4.6c2,1.1,4.2,1.7,6.5,1.6c1.4,0,2.9-0.2,4.2-0.6
            c1.2-0.4,2.3-1,3.3-1.7c0.9-0.7,1.7-1.5,2.3-2.5c0.6-0.9,1-1.9,1.2-2.9v-0.3h-5l-0.1,0.2c-0.2,0.7-0.6,1.3-1.1,1.8
            c-0.6,0.6-1.3,1-2,1.3c-0.9,0.3-1.8,0.5-2.8,0.5c-1.3,0-2.6-0.3-3.7-0.9c-1.1-0.6-1.9-1.6-2.4-2.7c-0.5-1.2-0.8-2.6-0.8-3.9h18.2
            v-1.8c0-2.3-0.4-4.7-1.4-6.8C116.2,14,114.8,12.4,113.1,11.3z M101.2,17.6c0.5-1.1,1.3-2.1,2.4-2.7c1-0.6,2.2-0.9,3.4-0.9
            c1.2,0,2.3,0.3,3.4,0.9c1,0.6,1.8,1.6,2.3,2.7c0.4,1,0.7,2,0.8,3.1h-12.9C100.5,19.6,100.8,18.6,101.2,17.6z"/>
        <path class="st0" d="M144.1,14.5H144c-0.7-1.5-1.9-2.7-3.3-3.6c-1.5-0.9-3.1-1.3-4.8-1.3c-2,0-4,0.5-5.6,1.6
            c-1.7,1.1-3,2.7-3.7,4.6c-0.9,2.2-1.4,4.7-1.3,7.1c-0.1,2.4,0.4,4.9,1.3,7.1c0.8,1.9,2.1,3.5,3.7,4.6c1.7,1.1,3.7,1.7,5.7,1.6
            c3.4,0.1,6.6-1.8,8.1-4.9h0.1v4.3h5.3V0.6h-5.3V14.5z M143.2,27.6c-0.5,1.2-1.3,2.3-2.4,3.1v0c-1,0.7-2.2,1.1-3.5,1.1
            c-1.3,0-2.5-0.4-3.6-1.1c-1.1-0.8-1.9-1.8-2.3-3c-0.6-1.5-0.8-3.1-0.8-4.7c0-1.6,0.2-3.2,0.8-4.7c0.5-1.2,1.3-2.2,2.3-3
            c1-0.7,2.3-1.1,3.6-1.1c1.3,0,2.5,0.4,3.5,1.1c1.1,0.8,1.9,1.8,2.4,3c0.6,1.5,0.9,3,0.9,4.6C144.1,24.6,143.8,26.2,143.2,27.6z"
            />
        <path class="st0" d="M175.2,25.1c0,1.2-0.2,2.4-0.7,3.5c-0.5,1-1.2,1.8-2.1,2.3c-1,0.6-2.1,0.9-3.2,0.8c-1.5,0.1-3-0.4-4.1-1.5
            c-1-1.3-1.4-2.9-1.3-4.4V10.1h-5.3v16.7c0,1.8,0.3,3.5,1.1,5.1c0.6,1.4,1.7,2.5,3,3.3c1.5,0.8,3.1,1.2,4.8,1.1
            c1.7,0.1,3.4-0.4,4.9-1.2c1.3-0.8,2.3-1.8,3-3.2h0.1v3.8h5.3V10.1h-5.3V25.1z"/>
        <rect x="189.7" y="0.6" class="st0" width="5.3" height="35.2"/>
        <path class="st0" d="M226.5,22.6c0.1-2.3-0.4-4.7-1.4-6.8c-0.9-1.9-2.3-3.4-4-4.5c-1.9-1.1-4-1.7-6.2-1.6
            c-2.2-0.1-4.4,0.5-6.2,1.7c-1.8,1.1-3.2,2.8-4.1,4.7c-1,2.2-1.5,4.6-1.5,7c-0.1,2.4,0.4,4.8,1.5,7c0.9,1.9,2.3,3.5,4.2,4.6
            c2,1.1,4.2,1.7,6.5,1.6c1.4,0,2.9-0.2,4.2-0.6c1.2-0.4,2.3-1,3.3-1.7c0.9-0.7,1.7-1.6,2.3-2.5c0.6-0.9,1-1.9,1.2-2.9v-0.3h-5
            l-0.1,0.2c-0.2,0.7-0.6,1.3-1.1,1.8c-0.6,0.6-1.3,1-2,1.3c-0.9,0.3-1.8,0.5-2.8,0.5c-1.3,0-2.6-0.3-3.7-0.9
            c-1.1-0.6-1.9-1.6-2.4-2.7c-0.5-1.2-0.8-2.6-0.8-3.9h18.2V22.6z M209.2,17.6c0.5-1.1,1.3-2.1,2.4-2.7c1-0.6,2.2-0.9,3.4-0.9
            c1.2,0,2.3,0.3,3.4,0.9c1,0.6,1.8,1.6,2.3,2.7c0.4,1,0.7,2,0.8,3.1h-12.9C208.5,19.6,208.8,18.6,209.2,17.6z"/>
    </g>
    <rect x="594.9" class="st0" width="61.3" height="4.9"/>
    <rect x="607.8" y="17.2" class="st0" width="35.2" height="4.9"/>
    <rect x="618.1" y="35.8" class="st0" width="14.9" height="4.9"/>
</svg>
